// extracted by mini-css-extract-plugin
export default {"head":"head__IY5o99","openBtn":"openBtn__hFzRzB","brand":"brand__C8dqBF"};